/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Pre_Purchase_DescriptionInputs */



/**
* | output |
* | --- |
* | "Condition surveys that protect owners, buyers and charterers at handover." |
*
* @param {Service_Pre_Purchase_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const service_pre_purchase_description = /** @type {((inputs?: Service_Pre_Purchase_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Pre_Purchase_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("在交接环节保障船东、买方和租家利益的状况检验。")
	return /** @type {LocalizedString} */ ("Condition surveys that protect owners, buyers and charterers at handover.")
});